import React, { FC } from 'react';
import {
  CarouselProduct,
  CarouselProductClickPayload,
  CarouselProductVisiblePayload,
  Placement,
  ProductCarousel,
} from '@noths/polaris-client-ribbons-design-system';
import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { useRichRelevanceData } from '../../../hooks/useRichRelevanceData/useRichRelevanceData';
import { RichRelevanceProduct } from '../../../types/RecentlyViewed';
import { sendProductClickEvent, sendProductShelfImpressionEvent } from './tracking';
export interface RecentlyViewedProps {
  currency: CurrencyCode;
  items?: RichRelevanceProduct[];
  title?: string;
  strategy?: string;
  placementType: Placement;
}

export const RecentlyViewed: FC<RecentlyViewedProps> = ({
  currency,
  items = [],
  title = '',
  strategy = '',
  placementType,
}: RecentlyViewedProps) => {
  const products = useRichRelevanceData(items);

  return (
    <div data-testid="RecentlyViewedCarousel">
      <ProductCarousel
        products={products as CarouselProduct[]}
        placementTitle={title}
        placementType={placementType}
        currency={currency}
        onComponentVisible={(payload: CarouselProductVisiblePayload) =>
          sendProductShelfImpressionEvent(payload, products, strategy)
        }
        onProductClick={(payload: CarouselProductClickPayload) =>
          sendProductClickEvent(payload, products, strategy)
        }
      />
    </div>
  );
};
